<div class="filter-container" [class.pop-up]="isPopUp">
  @if (isPopUp) {
    <div class="pop-up-header">
      <h3>{{ popUpTitle }}</h3>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="cursor: pointer"
        (click)="closePopUp()"
      >
        <path
          d="M19.5459 17.954C19.7573 18.1653 19.876 18.452 19.876 18.7509C19.876 19.0497 19.7573 19.3364 19.5459 19.5477C19.3346 19.7591 19.048 19.8778 18.7491 19.8778C18.4502 19.8778 18.1635 19.7591 17.9522 19.5477L12 13.5937L6.04594 19.5459C5.8346 19.7572 5.54795 19.8759 5.24907 19.8759C4.95018 19.8759 4.66354 19.7572 4.45219 19.5459C4.24085 19.3345 4.12212 19.0479 4.12212 18.749C4.12212 18.4501 4.24085 18.1635 4.45219 17.9521L10.4063 11.9999L4.45407 6.04586C4.24272 5.83451 4.12399 5.54787 4.12399 5.24898C4.12399 4.9501 4.24272 4.66345 4.45407 4.45211C4.66541 4.24076 4.95206 4.12203 5.25094 4.12203C5.54983 4.12203 5.83647 4.24076 6.04782 4.45211L12 10.4062L17.9541 4.45117C18.1654 4.23983 18.4521 4.12109 18.7509 4.12109C19.0498 4.12109 19.3365 4.23983 19.5478 4.45117C19.7592 4.66251 19.8779 4.94916 19.8779 5.24804C19.8779 5.54693 19.7592 5.83358 19.5478 6.04492L13.5938 11.9999L19.5459 17.954Z"
          fill="#1F1F1F"
        />
      </svg>
    </div>
  }
  <div class="input-container">
    <input
      type="text"
      [placeholder]="placeholder"
      [ngModel]="searchKey"
      (ngModelChange)="onChangeKey($event)"
    />
  </div>
  <div class="chip-container">
    <common-chips
      [options]="filteredOptions"
      [groupedOption]="true"
      (removeOption)="removeOption($event)"
    ></common-chips>
  </div>
  <div class="options-wrapper">
    @if (filteredOptions?.length) {
      @if (showSelectAll) {
        <label
          class="d-flex align-items-center"
          style="cursor: pointer; font-size: 14px; font-weight: 400; margin-bottom: 2rem;"
        >
          <input
            type="checkbox"
            [ngModel]="isAllSelected"
            (ngModelChange)="toggleSelectAll($event)"
            class="d-none"
          />
          @if (isAllSelected) {
            <img
              src="/assets/media/icons/checkbox-checked.svg"
              class="me-2"
            />
          } @else {
            <img
              src="/assets/media/icons/checkbox-unchecked.svg"
              class="me-2"
            />
          }
          Select all
        </label>
      }
      
      <cdk-virtual-scroll-viewport
        itemSize="50"
        class="options d-flex"
        [style.height.px]="dropdownHeight"
      >
        <div
          *cdkVirtualFor="let group of filteredOptions; trackBy: trackByGroupId"
          class="group mb-4"
        >
          <!-- Group Checkbox -->
          <label
            class="group-label d-flex align-items-center"
            style="cursor: pointer"
          >
            <input
              type="checkbox"
              [(ngModel)]="group.selected"
              (change)="toggleGroup(group)"
              class="d-none"
            />
            @if (group.selected) {
              <img
                src="/assets/media/icons/checkbox-checked.svg"
                class="me-2"
              />
            } @else {
              <img
                src="/assets/media/icons/checkbox-unchecked.svg"
                class="me-2"
              />
            }
            {{ group.name }}
          </label>
          <div class="d-flex">
            @for (option of group.options; track option) {
              <div class="option-label d-flex align-items-center child-option">
                <label
                  class="d-flex align-items-center"
                  style="cursor: pointer; margin-left: 20px"
                >
                  <input
                    type="checkbox"
                    [(ngModel)]="option.selected"
                    (change)="updateSelectAll(group)"
                    class="d-none"
                  />
                  @if (option.selected) {
                    <img
                      src="/assets/media/icons/checkbox-checked.svg"
                      class="me-2"
                    />
                  } @else {
                    <img
                      src="/assets/media/icons/checkbox-unchecked.svg"
                      class="me-2"
                    />
                  }
                  {{ option.label }}
                </label>
              </div>
            }
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    }

    @if (!filteredOptions?.length) {
      <div class="d-flex align-items-center justify-content-center w-100">
        <img src="/assets/media/icons/no-results-filter.svg" alt="no-results" />
      </div>
    }
  </div>
  <div class="action-buttons" [class.pop-up]="isPopUp">
    <div (click)="applyFilters()" class="apply-button">Apply</div>
    <div (click)="clearAll()" class="clear-button">Clear all</div>
  </div>
</div>
